import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ContactTableDash.css';

const ContactTableDash = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({ name: '', phone: '', message: '' });

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await axios.get('/api/contact');
      setMessages(response.data);
      setLoading(false);
    } catch (error) {
      console.error('שגיאה בקבלת הודעות:', error);
      setLoading(false);
    }
  };

  const deleteMessage = async (id) => {
    try {
        await axios.delete(`/api/contact/idcontactdash/${id}`);
      fetchMessages();
    } catch (error) {
      console.error('שגיאה במחיקה:', error);
    }
  };

  const handleEditClick = (msg) => {
    setEditId(msg.id);
    setEditData({ name: msg.name, phone: msg.phone, message: msg.message });
  };

  const handleSaveEdit = async () => {
    try {
        await axios.put(`/api/contact/idcontactdash/${editId}`, editData);
      setEditId(null);
      fetchMessages();
    } catch (error) {
      console.error('שגיאה בעדכון:', error);
    }
  };

  const handleInputChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  if (loading) return <div>טוען נתונים...</div>;

  return (
    <div className="contact-table-wrapper">
      <h2 className="contact-table-title">פניות שהתקבלו</h2>
      <table className="contact-table-table">
        <thead className="contact-table-thead">
          <tr className="contact-table-tr">
            <th className="contact-table-th">מס׳</th>
            <th className="contact-table-th">שם</th>
            <th className="contact-table-th">נושא</th>
            <th className="contact-table-th">אימייל</th>
            <th className="contact-table-th">טלפון</th>
            <th className="contact-table-th">הודעה</th>
            <th className="contact-table-th">פעולות</th>
          </tr>
        </thead>
        <tbody className="contact-table-tbody">
          {messages.map((msg, index) => (
            <tr key={msg.id} className="contact-table-tr">
              <td className="contact-table-td">{index + 1}</td>
              <td className="contact-table-td">
                {editId === msg.id ? (
                  <input name="name" value={editData.name} onChange={handleInputChange} />
                ) : (
                  msg.name
                )}
              </td>
              <td className="contact-table-td">{msg.subject}</td>
              <td className="contact-table-td">{msg.email}</td>
              <td className="contact-table-td">
                {editId === msg.id ? (
                  <input name="phone" value={editData.phone} onChange={handleInputChange} />
                ) : (
                  msg.phone
                )}
              </td>
              <td className="contact-table-td">
                {editId === msg.id ? (
                  <input name="message" value={editData.message} onChange={handleInputChange} />
                ) : (
                  msg.message
                )}
              </td>
              <td className="contact-table-td">
                {editId === msg.id ? (
                  <button onClick={handleSaveEdit}>💾 שמור</button>
                ) : (
                  <button onClick={() => handleEditClick(msg)}>✏️ ערוך</button>
                )}
                <button onClick={() => deleteMessage(msg.id)}>🗑 מחק</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContactTableDash;
